import { useEffect, useRef, useState } from "react";
// TODO: Replace with backend endpoint
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function ExportTasks() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const isAdmin = localStorage.getItem('isAdmin');

    const tableRef = useRef(null);

    const [tasks, setTasks] = useState<any[]>([]);

    useEffect(() => {
        const requestOptionsPost = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/stats/tasks', requestOptionsPost)
            .then(response => {
                if (response.status !== 200) {
                    navigate('/');
                }
                return response.json();
            })
            .then(data => {
                setTasks(data);
            });
    }, []);

    return (
        <div>
                {/* TODO: Replace with backend endpoint for Excel export */}
                <button disabled>Export (Pendiente)</button>

                <table  ref={tableRef}>
                 <tbody>
                    <tr>
                        <th>{ t("ID") }</th>
                        <th>{ t("User ID") }</th>
                        <th>{ t("Name") }</th>
                        <th>{ t("Number of pre-tasks") }</th>
                        <th>{ t("Number of subtasks") }</th>
                        <th>{ t("Number of post-tasks") }</th>
                        <th>{ t("Number of sessions") }</th>
                        <th>{ t("Aims") }</th>
                        <th>{ t("Proficiency level") }</th>
                        <th>{ t("Cloned") }</th>
                        <th>{ t("Original source") }</th>
                        <th>{ t("Original task") }</th>
                    </tr>
                    { tasks.map((t: any) => {
                        return <tr>
                            <td>{ t.id }</td>
                            <td>{ t.user_id }</td>
                            <td>{ t.name }</td>
                            <td>{ t.num_pretasks }</td>
                            <td>{ t.num_subtasks }</td>
                            <td>{ t.num_postasks }</td>
                            <td>{ t.num_sessions }</td>
                            <td>{ t.aims.join('|') }</td>
                            <td>{ t.proficiency_level.join('|') }</td>
                            <td>{ t.clonned }</td>
                            <td>{ t.original_source }</td>
                            <td>{ t.original_task }</td>
                        </tr>;
                    })}
                  </tbody>
                </table>

            </div>);
}